var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { SuggestionList, SuggestionItem, AutocompleteInput, AutocompleteMulti, AutocompleteContainer, SuggestionContainer, SuggestionChip, } from './styles';
var Autocomplete = /** @class */ (function (_super) {
    __extends(Autocomplete, _super);
    function Autocomplete(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (e) {
            var _a = _this.props, suggestions = _a.suggestions, sanitizeInput = _a.sanitizeInput;
            var value = e.currentTarget.value;
            // filter the list of suggestions based on input
            var filteredSuggestions = [];
            var matches = value === null || value === void 0 ? void 0 : value.match(_this.regExp);
            if (matches) {
                matches.forEach(function (match) {
                    var cleanValue = match.replace(/[${}]/g, '');
                    filteredSuggestions = suggestions.filter(function (suggestion) {
                        return suggestion.name.includes(cleanValue);
                    });
                });
            }
            if (sanitizeInput) {
                // remove invalid values
                var allMatches = value.match(_this.fullRegExp);
                if (allMatches) {
                    var possibleSuggestions_1 = suggestions.map(function (suggestion) { return suggestion.name; });
                    allMatches.forEach(function (match) {
                        var cleanValue = match.replace(/[${}]/g, '');
                        if (!possibleSuggestions_1.includes(cleanValue)) {
                            value = value.replace(match, '');
                        }
                    });
                }
            }
            _this.setState({
                activeSuggestion: 0,
                filteredSuggestions: filteredSuggestions,
                showSuggestions: true,
                userInput: value,
            });
            _this.props.onChange(value);
        };
        _this.onClick = function (e) {
            var innerText = e.currentTarget.innerText;
            var userInput = _this.state.userInput;
            if (userInput.match(_this.regExp)) {
                userInput = userInput.replace(_this.regExp, "${".concat(innerText, "}"));
            }
            _this.setState({
                activeSuggestion: 0,
                filteredSuggestions: [],
                showSuggestions: false,
                userInput: userInput,
            });
            _this.props.onChange(userInput);
        };
        _this.onKeyDown = function (e) {
            var _a = _this.state, activeSuggestion = _a.activeSuggestion, filteredSuggestions = _a.filteredSuggestions;
            var userInput = _this.state.userInput;
            var key = e.key;
            if (userInput.match(_this.regExp) &&
                filteredSuggestions.length > 0 &&
                filteredSuggestions[activeSuggestion]) {
                userInput = userInput.replace(_this.regExp, "${".concat(filteredSuggestions[activeSuggestion].name, "}"));
            }
            if (key === 'Enter') {
                _this.setState({
                    activeSuggestion: 0,
                    showSuggestions: false,
                    userInput: userInput,
                });
                _this.props.onChange(userInput);
            }
            else if (key === 'ArrowUp') {
                _this.setState({
                    activeSuggestion: activeSuggestion !== 0
                        ? activeSuggestion - 1
                        : filteredSuggestions.length - 1,
                }, function () {
                    _this.scrollToRef(_this.state.activeSuggestion !== 0 ? 'start' : 'end');
                });
            }
            else if (key === 'ArrowDown') {
                if (activeSuggestion - 1 === filteredSuggestions.length) {
                    return;
                }
                var newActiveSuggestion = activeSuggestion + 1;
                _this.setState({
                    activeSuggestion: newActiveSuggestion >= filteredSuggestions.length
                        ? 0
                        : newActiveSuggestion,
                }, function () {
                    _this.scrollToRef(_this.state.activeSuggestion === 0 ? 'start' : 'end');
                });
            }
        };
        _this.scrollToRef = function (direction) {
            if (direction === void 0) { direction = 'end'; }
            if (_this.highlightedRef.current) {
                _this.highlightedRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: direction,
                });
            }
        };
        _this.state = {
            activeSuggestion: 0,
            filteredSuggestions: [],
            showSuggestions: false,
            userInput: props.value,
        };
        _this.highlightedRef = React.createRef();
        _this.regExp = /\${[^}]*$/g;
        _this.fullRegExp = /\$\{(.*?)\}/g;
        return _this;
    }
    Autocomplete.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({
                userInput: this.props.value,
            });
        }
    };
    Autocomplete.prototype.render = function () {
        var _this = this;
        var _a = this.state, showSuggestions = _a.showSuggestions, userInput = _a.userInput, filteredSuggestions = _a.filteredSuggestions, activeSuggestion = _a.activeSuggestion;
        var suggestionsListComponent = null;
        if (showSuggestions && userInput && filteredSuggestions.length > 0) {
            suggestionsListComponent = (_jsx(SuggestionList, { children: filteredSuggestions.map(function (suggestion, index) { return (_jsx(SuggestionItem, __assign({ isActive: index === activeSuggestion ? 1 : 0, ref: function (ref) {
                        if (index === activeSuggestion) {
                            _this.highlightedRef.current = ref;
                        }
                    }, onClick: _this.onClick }, { children: suggestion.name }), suggestion.name)); }) }));
        }
        var _b = this.props, multi = _b.multi, style = _b.style, discrete = _b.discrete, displaySuggestions = _b.displaySuggestions, _c = _b.suggestions, suggestions = _c === void 0 ? [] : _c, disabled = _b.disabled, placeholder = _b.placeholder;
        return (_jsxs(AutocompleteContainer, { children: [multi && (_jsx(AutocompleteMulti, { rows: 4, style: style, onChange: this.onChange, onKeyDown: this.onKeyDown, value: userInput })), !multi && (_jsx(AutocompleteInput, { discrete: discrete, type: "text", style: style, onChange: this.onChange, disabled: disabled, placeholder: placeholder, onKeyDown: this.onKeyDown, value: userInput })), displaySuggestions && suggestions.length > 0 && (_jsx(SuggestionContainer, { children: suggestions.map(function (suggestion) { return (_jsx(SuggestionChip, { children: "${".concat(suggestion.name, "}") }, suggestion.name)); }) })), suggestionsListComponent] }));
    };
    return Autocomplete;
}(React.PureComponent));
export default Autocomplete;
